<div class="max-auto">
    <div class="sa-coming-soon-panel d-flex flex-center align-center">
        <h1 class="h2 text-dark">Coming Soon</h1>
    </div>
</div>
